import '../Styles/boxplotStyles.css';
import { Component } from 'preact';
import { index } from 'd3';
var alphaShape = require('alpha-shape')
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Formfield from 'preact-material-components/FormField';
import Switch from 'preact-material-components/Switch';
import {contorno_lateral} from '../assets/data/contorno_lateral.js';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

class BoxplotComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      titleDropDownCategory: ["Category","Category" ], //Titulo categorias
      titleDropDownSubcategory:["Subcategory","Subcategory"], //Titulo subcategorías
      indexCategory:[-1,-1], //Index contorno seleccionado (categoria)
      indexSubcategory:[-1,-1], ///Index contorno seleccionado (subcategoria)
      percentil50:[true,true],//checkbox percentil 50
      percentil90:[true,true], //checkbox percentil 90
      categories:[],//lista de Dropdown.Item de categoria
      subcategories:[[],[]], //lista de Dropdown.Item de subcategoria
      BRContours:[[],[]], //lista de puntos que forman los contornos
      svg:[],
      switchHighlighted:false, //swicth "Only Highlighted Data"
      selectedItems: null,
      data_detrital:[],
      idBox:[false,false,false,false,false,false,false,false,false]
    }
    this.drawBoxplot = this.drawBoxplot.bind(this);

  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){
    this.drawBoxplot();
  }

  drawLine(e){
    let idBox = this.state.idBox;
    idBox[parseInt(e)] = !idBox[parseInt(e)];
    this.setState({idBox:idBox});
  }

  drawBoxplot(){

    //obtengo el elemento quimico por el que voy a dibujar
    if(this.props.colorBy[0] == "Attribute"){
      var colorBy = this.props.colorBy[1];
    }

    // set the dimensions and margins of the graph
    var margin = {top: 15, right: 15, bottom:40 , left: 40},
    width = 200 - margin.left - margin.right,
    height = 200 - margin.top - margin.bottom;

    var categories = ["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"];
    var keys = ["Alaskan","Alkali","Basalt","Komatiite","Layered","Metamorphic","Ophiolite","Xenoliths"];
    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])

    //borro contenido de los div
    for(let j in keys){
      d3.select("#"+keys[j]).selectAll("*").remove()
    }

    d3.select("#container-line").selectAll("*").remove()

    //Dimensiones line chart grande
    var marginLine = {top: 30, right: 30, bottom: 30, left: 50},
    widthLine = 710 - marginLine.left - marginLine.right,
    heightLine = 610 - marginLine.top - marginLine.bottom;

    var svgLine = d3.select("#container-line")
    .append("svg")
    .attr("width", widthLine + marginLine.left + marginLine.right)
    .attr("height", heightLine + marginLine.top + marginLine.bottom)
    .append("g")
    .attr("transform", "translate(" + marginLine.left + "," + marginLine.top + ")");

    var x = d3.scaleLinear()
    .domain([0,1])
    .rangeRound([0, width])
    // make x domain start and end nice
    .nice();

    var numBins = 10;
    var thresholds = x.ticks(numBins);

    const histogram = d3.histogram()
    .value(d => d)
    .domain(x.domain())
    .thresholds(x.ticks(10));

    // Definir la escala x el eje X
    var xScale = d3.scaleLinear()
    .domain([0,1])
    .rangeRound([0, width])

    // Línea
    const line = d3.line().curve(d3.curveBundle)
    .x(d => xScale(d.x0))
    .y(d => yScale(d.length));

    var xLine = d3.scaleLinear()
    .domain([0,1])
    .rangeRound([0, widthLine])
    // make x domain start and end nice
    .nice();

    var thresholdsLine = xLine.ticks(numBins);

    const histogramLine = d3.histogram()
    .value(d => d)
    .domain(xLine.domain())
    .thresholds(xLine.ticks(10));

    // Definir la escala x el eje X
    var xScaleLine = d3.scaleLinear()
    .domain([0,1])
    .rangeRound([0, widthLine])

    // Línea
    const line2 = d3.line().curve(d3.curveBundle)
    .x(d => xScaleLine(d.x0))
    .y(d => yScaleLine(d.length));

    for(let i in categories){

      var data = this.props.complete_data.filter((d, index) => { if (d.Category1 == categories[i]) { return parseFloat(d[colorBy]);}});
      var seleccdata = this.props.complete_data.filter((d, index) => { if (d.Category1 == categories[i] && this.props.filteredData_umap.includes(index)) { return parseFloat(d[colorBy]);}});

      let auxx = d3.extent(data.map(l=>l[colorBy]));
      var min = auxx[0];
      var max = auxx[1];

      data = data.map((d, index) => { return (parseFloat(d[colorBy])-min)/(max-min)});
      seleccdata = seleccdata.map((d, index) => { return (parseFloat(d[colorBy])-min)/(max-min)});

      var bins = d3.histogram()
      .domain(x.domain())
      .thresholds(thresholds)
      (data);

      var seleccBins = d3.histogram()
      .domain(x.domain())
      .thresholds(thresholds)
      (seleccdata);

      // the value is the height
      bins = bins.map(function(d) {
        d.value = d.length;
        return d;
      })

      // the value is the height
      seleccBins = seleccBins.map(function(d) {
        d.value = d.length;
        return d;
      })

      var y = d3.scaleLinear()
      .domain([0, d3.max(bins, function(d) { return d.value; })])
      .range([height, 0]);


      // Definir la escala y el eje Y
      var yScale = d3.scaleLinear()
      .domain([0, d3.max(bins, function(d) { return d.value; })])
      .range([height, 0]);


      var svg = d3.select("#"+keys[i])
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")


      if(this.state.idBox[i]){
        svg.append("rect")
          .attr("width", 300)
          .attr("height", 320)
          .attr("fill", "#ccc")
          .style("opacity", 0.3)
          .attr("transform", "translate(" + -40 + "," + 0 + ")");
        }

        svg
        .append("g")
        .call(d3.axisLeft(y).ticks(6));




      var bar = svg.selectAll(".bar")
      .data(bins)
      .enter().append("g")
      .attr("class", "bar")
      .attr("transform", function(d) {return "translate(" + x(d.x0) + "," + y(d.value) + ")";});
      bar.append("rect")
      .attr("x", 0)
      .style("fill", function(d){ return scaleColor(categories[i]);})
      .style("opacity", function(d){ return 0.3;})

      .attr("width", function(d) { return (x(d.x1) - x(d.x0) ); })
      .attr("height", function(d) { return height - (y(d.value)); })


      if(seleccdata.length>0){
        var bar2 = svg.selectAll(".bar2")
        .data(seleccBins)
        .enter().append("g")
        .attr("class", "bar")
        .attr("transform", function(d) {return "translate(" + x(d.x0) + "," + y(d.value) + ")";});
        bar2.append("rect")
        .attr("x", 0)
        .style("fill", function(d){ return scaleColor(categories[i]);})
        .style("opacity", function(d){ return 0.5;})

        .attr("width", function(d) { return (x(d.x1) - x(d.x0) ); })
        .attr("height", function(d) { return height - (y(d.value)); })
      }


      let binsLineProj = histogram(data);

      // Añadir la línea
      svg.append("path")
      .datum(binsLineProj)
      .attr("d", line)
      .attr("class", "rect")
      .attr("fill", "none" )
      .attr("stroke", scaleColor(categories[i]))
      .attr("stroke-width", 1);

      if(seleccdata.length>0){
        // Añadir la línea
        svg.append("path")
        .datum(histogram(seleccdata))
        .attr("d", line)
        .attr("class", "rect")
        .attr("fill", "none" )
        .attr("stroke", scaleColor(categories[i]))
        .style("opacity",1)
        .attr("stroke-width", 1.5);
      }

      svg.append("g")
      .attr("class", "axis axis--x axisTable")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x).ticks(6).tickValues([0,0.2,0.4,0.6,0.8,1]).tickFormat(d3.format(".1f")).tickSizeInner(3).tickSizeOuter(0));

      svg.append("text")
        .attr("text-anchor", "end")
        .attr("y", height+30)
        .attr("x", width)
        .text(""+categories[i])



      // Dibujo line chart grande
      var binsLine = d3.histogram()
      .domain(xLine.domain())
      .thresholds(thresholdsLine)
      (data);

      // the value is the height
      binsLine = binsLine.map(function(d) {
        d.value = d.length;
        return d;
      })

      var yLine = d3.scaleLinear()
      .domain([0, d3.max(binsLine, function(d) { return d.value; })])
      .range([heightLine, 0]);

      // Definir la escala y el eje Y
      var yScaleLine= d3.scaleLinear()
      .domain([0, d3.max(binsLine, function(d) { return d.value; })])
      .range([heightLine, 0]);

      if(this.state.idBox[i]){
        // Añadir la línea
        svgLine.append("path")
        .datum(binsLineProj)
        .attr("d", line2)
        .attr("class", "rect")
        .attr("fill", "none" )
        .attr("stroke", scaleColor(categories[i]))
        .attr("stroke-width", 1);

        if(seleccdata.length>0){
          // Añadir la línea
          svgLine.append("path")
          .datum(histogram(seleccdata))
          .attr("d", line2)
          .attr("class", "rect")
          .attr("fill", "none" )
          .attr("stroke", scaleColor(categories[i]))
          .attr("stroke-width", 3);
        }
      }
    }

    d3.select("#user").selectAll("*").remove()

    var svg = d3.select("#user")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


    svg.append("rect")
      .attr("width", 300)
      .attr("height", 320)
      .attr("fill", "#ccc")
      .style("opacity", 0.3)
      .attr("transform", "translate(" + -40 + "," + 0 + ")");


    x = d3.scaleLinear()
    .domain([0,1])
    .rangeRound([0, width])
    // make x domain start and end nice
    .nice();

    svg.append("g")
    .attr("class", "axis axis--x axisTable")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x).ticks(6).tickValues([0,0.2,0.4,0.6,0.8,1]).tickFormat(d3.format(".1f")).tickSizeInner(3).tickSizeOuter(0));


    svg.append("text")
      .attr("text-anchor", "end")
      .attr("y", height+30)
      .attr("x", width)
      .text(" User data")


    if(this.props.detrital_data.length>0){

      var data = this.props.detrital_data.map((d, index) => { return parseFloat(d[colorBy]);});
      var seleccData = this.props.detrital_data.filter((d, index) => {if(this.props.filteredData_detrital.includes(index)) return parseFloat(d[colorBy]);});

      seleccData = seleccData.map((d, index) => { return parseFloat(d[colorBy])});


      let auxx = d3.extent(data);
      var min = auxx[0];
      var max = auxx[1];

      data = data.map((d, index) => { return (d-min)/(max-min)});
      seleccData = seleccData.map((d, index) => { return (d-min)/(max-min)});


      var bins = d3.histogram()
      .domain(x.domain())
      .thresholds(thresholds)
      (data);

      var seleccBins = d3.histogram()
      .domain(x.domain())
      .thresholds(thresholds)
      (seleccData);

      // the value is the height
      bins = bins.map(function(d) {
        d.value = d.length;
        return d;
      })

      // the value is the height
      seleccBins = seleccBins.map(function(d) {
        d.value = d.length;
        return d;
      })

      var y = d3.scaleLinear()
      .domain([0, d3.max(bins, function(d) { return d.value; })])
      .range([height, 0]);


      // Definir la escala y el eje Y
      var yScale = d3.scaleLinear()
      .domain([0, d3.max(bins, function(d) { return d.value; })])
      .range([height, 0]);


      svg
      .append("g")
      .call(d3.axisLeft(y).ticks(6));


      var bar = svg.selectAll(".bar")
      .data(bins)
      .enter().append("g")
      .attr("class", "bar")
      .attr("transform", function(d) {return "translate(" + x(d.x0) + "," + y(d.value) + ")";});
      bar.append("rect")
      .attr("x", 0)
      .style("fill", function(d){ return "#000";})
      .style("opacity", function(d){ return 0.3;})

      .attr("width", function(d) { return (x(d.x1) - x(d.x0) ); })
      .attr("height", function(d) { return height - (y(d.value)); })


      if(seleccData.length>0){
        var bar2 = svg.selectAll(".bar2")
        .data(seleccBins)
        .enter().append("g")
        .attr("class", "bar")
        .attr("transform", function(d) {return "translate(" + x(d.x0) + "," + y(d.value) + ")";});
        bar2.append("rect")
        .attr("x", 0)
        .style("fill", function(d){ return "#000";})
        .style("opacity", function(d){ return 0.5;})

        .attr("width", function(d) { return (x(d.x1) - x(d.x0) ); })
        .attr("height", function(d) { return height - (y(d.value)); })
      }


      let binsLineProj = histogram(data);

      // Añadir la línea
      svg.append("path")
      .datum(binsLineProj)
      .attr("d", line)
      .attr("class", "rect")
      .attr("fill", "none" )
      .attr("stroke", "#000")
      .attr("stroke-width", 1);

      if(seleccData.length>0){
        // Añadir la línea
        svg.append("path")
        .datum(histogram(seleccData))
        .attr("d", line)
        .attr("class", "rect")
        .attr("fill", "none" )
        .attr("stroke", "#000")
        .style("opacity",1)
        .attr("stroke-width", 1.5);
      }




      // Dibujo line chart grande
      var binsLine = d3.histogram()
      .domain(xLine.domain())
      .thresholds(thresholdsLine)
      (data);

      // the value is the height
      binsLine = binsLine.map(function(d) {
        d.value = d.length;
        return d;
      })

      var yLine = d3.scaleLinear()
      .domain([0, d3.max(binsLine, function(d) { return d.value; })])
      .range([heightLine, 0]);

      // Definir la escala y el eje Y
      var yScaleLine= d3.scaleLinear()
      .domain([0, d3.max(binsLine, function(d) { return d.value; })])
      .range([heightLine, 0]);

      // Añadir la línea
      svgLine.append("path")
      .datum(binsLineProj)
      .attr("d", line2)
      .attr("class", "rect")
      .attr("fill", "none" )
      .attr("stroke", "#000")
      .style("opacity",1)
      .attr("stroke-width", 1);

      // Añadir la línea
      svgLine.append("path")
      .datum(histogram(seleccData))
      .attr("d", line2)
      .attr("class", "rect")
      .attr("fill", "none" )
      .attr("stroke", "#000")
      .style("opacity",1)
      .attr("stroke-width", 2);


      svgLine.append("g")
      .attr("class", "axis axis--x axisTable")
      .attr("transform", "translate(0," + heightLine + ")")
      .call(d3.axisBottom(xLine).ticks(5).tickValues([0,0.25,0.5,0.75,1]).tickFormat(d3.format(".2f")).tickSizeInner(3).tickSizeOuter(0));
      svgLine
      .append("g")
      .call(d3.axisLeft(yLine).ticks(0));


    }


    svgLine.append("g")
    .attr("class", "axis axis--x axisTable")
    .attr("transform", "translate(0," + heightLine + ")")
    .call(d3.axisBottom(xLine).ticks(5).tickValues([0,0.25,0.5,0.75,1]).tickFormat(d3.format(".2f")).tickSizeInner(3).tickSizeOuter(0));
    svgLine
    .append("g")
    .call(d3.axisLeft(yLine).ticks(0));

    // Add X axis label:
    svgLine.append("text")
        .attr("text-anchor", "end")
        .attr("x", widthLine/2)
        .attr("y", heightLine + marginLine.top)
        .text(""+colorBy);

    // Y axis label:
    svgLine.append("text")
        .attr("text-anchor", "end")
        .attr("transform", "rotate(-90)")
        .attr("y", -marginLine.left+20)
        .attr("x", -marginLine.top-200)
        .text("Frequency")


  }


  render(){

    return (
      <div class="row">
      <h3> Distribution of {this.props.colorBy[1]}</h3>
      <br/>
      <div id="box-container" style={{marginTop:"50px"}}>
      <div class="row">
      <div class="col-lg">
        <Button className="btn" onClick={(e)=>this.drawLine(0)}>
          <div id="Alaskan"></div>
        </Button>
      </div>
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(1)}>
        <div id="Alkali"></div>
      </Button>
      </div>
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(2)}>
        <div id="Basalt"></div>
      </Button>
      </div>
      </div>
      <div class="row">
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(3)}>
        <div id="Komatiite"></div>
      </Button>
      </div>
      <div class="col-lg">
      <div id="user"></div>
      </div>
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(4)}>
        <div id="Layered"></div>
      </Button>
      </div>
      </div>
      <div class="row">
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(5)}>
        <div id="Metamorphic"></div>
      </Button>
      </div>
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(6)}>
        <div id="Ophiolite"></div>
      </Button>
      </div>
      <div class="col-lg">
      <Button className="btn" onClick={(e)=>this.drawLine(7)}>
        <div id="Xenoliths"></div>
      </Button>
      </div>
      </div>
      </div>
      <div id="container-line">
      </div>
      </div>
    );
  }
}
export default BoxplotComponent;
